import { MyCAIApiService } from "../MyCAIApiService";
import { IMyCAIApiConfig } from "../../configs/IMyCAIApiConfig";
import { paramBuilder, ParamBuilder } from "../../utilities/uri";

export class SiftServiceApi extends MyCAIApiService {
    public Requests: RequestsService
    public paramBuilder: ParamBuilder;

    constructor(config: IMyCAIApiConfig) {
        super(config);
        this.paramBuilder = paramBuilder;

        this.Requests = new RequestsService(this, this.paramBuilder);
    }
}

class RequestsService {
    private apiService: SiftServiceApi;
    private paramBuilder: ParamBuilder;

    constructor(apiService: SiftServiceApi, paramBuilder: ParamBuilder) {
        this.apiService = apiService;
        this.paramBuilder = paramBuilder;
    }

    public async getProcesses(): Promise<any> {
        const endpoint = 'v1/Requests/accessible-processes'
        return this.apiService.sendRequest({
            method: "get",
            endpoint,
        });
    }

    public async startProcess(processId: any, title: string, files: any): Promise<any> {
        const endpoint = `v1/Process/${processId}/start`
        return this.apiService.sendPollingRequest({
            method: "post",
            endpoint,
            data: {
                "Title":title,
                "FormData": {},
                "Files": files ?? []
            }
        });
    }

    public async getRequest(requestId: any): Promise<any> {
        const endpoint = `v1/RequestDetail/${requestId}`
        return this.apiService.sendRequest({
            method: "get",
            endpoint,
        })
    }

    public async getRequests(processId: any): Promise<any> {
        let query = this.paramBuilder({
            processId : processId
        })
        const endpoint = `v1/Requests${query}`
        return this.apiService.sendRequest({
            method: "get",
            endpoint,

        })
    }

    public async takeAction(requestId: any, actionId: any): Promise<any> {
        const endpoint = `v1/Requests/${requestId}/action/${actionId}`
        return this.apiService.sendRequest({
            method: "post",
            endpoint,
        })
    }

    public async updateAnswer(responseId: string, questionId: string, questionType: number, obj: any): Promise<any> {
        const endpoint = `v1/Responses/${responseId}/answers/${questionId}`
        return this.apiService.sendRequest({
            method: "put",
            endpoint,
			data: {
                "questionType": questionType,
                ...obj,
            },
        })
    }
}

//public async markNotificationsAsRead(notificationIds: string[]): Promise<any> {
//    const endpoint = `/communications/notifications/mark-as-read`;
//    return this.sendRequest({
//        method: "put",
//        endpoint,
//        data: notificationIds,
//    });
//}

//public async deleteNotifications(notificationIds: string[]): Promise<any> {
//    const endpoint = `/communications/notifications`;
//    return this.sendRequest({
//        method: "delete",
//        endpoint,
//        data: notificationIds,
//    });
//}
